// msg
export const SET = 'SET';
export const SET_ME = 'SET_ME';
export const SET_CONTACT = 'SET_CONTACT';
export const SET_ONLINE_STATUS = 'SET_ONLINE_STATUS';
export const ADD_MSGS = 'ADD_MSGS';
export const DEL_MSGS = 'DEL_MSGS';
export const RESET_MSGS = 'RESET_MSGS';
export const UPDATE_MSG = 'UPDATE_MSG';
export const SET_HAVE_MORE_MSG = 'SET_HAVE_MORE_MSG';
export const SET_IS_SHOW_CAPTCHA = 'SET_IS_SHOW_CAPTCHA';
export const SET_CAPTCHA_TEMP_MSG_ID = 'SET_CAPTCHA_TEMP_MSG_ID';
export const SET_TOPIC = 'SET_TOPIC'; // 设置帖子信息
export const SET_IS_SHOW_EDITOR = 'SET_IS_SHOW_EDITOR';
export const UPDATE_NOW_VIDEO = 'UPDATE_NOW_VIDEO';
export const UPDATE_WOS_FILENAME = 'UPDATE_WOS_FILENAME';
export const DEL_MSG_TOAST = 'DEL_MSG_TOAST';
export const CARD_AJAX_TOAST = 'CARD_AJAX_TOAST';
export const ADD_NOTICE_MSGS = 'ADD_NOTICE_MSGS';
export const UPDATE_NOTICE_MSG = 'UPDATE_NOTICE_MSG';

// session
export const UPDATE_SESSIONS = 'UPDATE_SESSIONS';
export const REFRESH_SESSION = 'REFRESH_SESSION';
export const HAVE_MORE = 'HAVE_MORE';
export const ADD_FALSE_LAST_MSG = 'ADD_FALSE_LAST_MSG';
